module.exports = __webpack_public_path__ + "static/media/gitlab-devops.2a964e49.png";